import { useState } from 'react';
import { X, Maximize2, Minimize2, Video } from 'lucide-react';
import { Button } from './ui/button';

const JitsiMeet = ({ roomUrl, onClose, userName = "Participant" }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Extract room name from URL
  const roomName = roomUrl?.split('/').pop() || 'opora-vie-room';
  
  // Build Jitsi URL with config
  const jitsiUrl = `https://meet.jit.si/${roomName}#userInfo.displayName="${encodeURIComponent(userName)}"&config.prejoinPageEnabled=false&config.startWithAudioMuted=true&config.startWithVideoMuted=false&interfaceConfig.SHOW_JITSI_WATERMARK=false&interfaceConfig.SHOW_WATERMARK_FOR_GUESTS=false&interfaceConfig.DEFAULT_BACKGROUND="#f5f5f0"`;

  return (
    <div 
      className={`fixed z-50 bg-white rounded-2xl shadow-2xl border border-sand-200 overflow-hidden transition-all duration-300 ${
        isFullscreen 
          ? 'inset-4' 
          : 'bottom-4 right-4 w-[800px] h-[600px] max-w-[calc(100vw-2rem)] max-h-[calc(100vh-2rem)]'
      }`}
      data-testid="jitsi-container"
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-sage-600 text-white">
        <div className="flex items-center gap-2">
          <Video className="w-5 h-5" />
          <span className="font-medium">Consultation vidéo</span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsFullscreen(!isFullscreen)}
            className="text-white hover:bg-white/20"
          >
            {isFullscreen ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="text-white hover:bg-white/20"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
      
      {/* Jitsi iframe */}
      <iframe
        src={jitsiUrl}
        className="w-full h-[calc(100%-52px)]"
        allow="camera; microphone; fullscreen; display-capture; autoplay"
        title="Consultation vidéo Jitsi"
        data-testid="jitsi-iframe"
      />
    </div>
  );
};

export default JitsiMeet;
